module.exports = __webpack_public_path__ + "img/set_info.d35f58f1.svg";